export class DynamicFormFieldApiError extends Error {
  constructor(public path: string, public message: string) {
    super(message);
  }
}
